import { Feature } from '@/licenseManagement/licenseManagement.constants';
import { useHasValidFeature } from '@/licenseManagement/licenseManagement.store';
import { isApprovalFlowsEnabled } from '@/services/systemConfiguration.utilities';

/** Returns whether Approval Flows is enabled and covered by the shared Locking license. */
export function useApprovalFlowsEnabled(): boolean {
  const hasLicense = useHasValidFeature(Feature.Locking);
  return isApprovalFlowsEnabled() && hasLicense;
}
